// 1.引入Vue
import Vue from 'vue'

// 2.引入Vue
import App from './App.vue'
import router from './router'
import ElementUI  from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import store from './store';

import axios from 'axios'

import mavonEditor from 'mavon-editor';
import 'mavon-editor/dist/css/index.css';


import ECharts from 'vue-echarts'

import * as echarts from 'echarts';


Vue.component('v-chart', ECharts)

// 本地服务器路径
// axios.defaults.baseURL = 'http://localhost:8843/api'

// 线上服务器路径
axios.defaults.baseURL = 'https://www.dxzxip.com/api'


// 全局注册，之后可在其他组件中通过 this.$axios 发送数据
Vue.prototype.$axios = axios

// 阻止Vue在启动时生成生产提示
Vue.config.productionTip = false

Vue.use(ElementUI);

Vue.use(mavonEditor);

Vue.prototype.$echarts = echarts

/** 
 * 全局路由守卫： 参数解读：to:到哪里； from:从哪个路由离开；next：路由控制参数
*/
router.beforeEach((to, from, next) => {

  // 1.从localStore中取出token, 表示用户已经登录，并且是去访问 '/admin'时
  if (store.state.accessToken && to.path.startsWith('/admin')) {

    // 初始化菜单信息
    initAdminMenu(router, store)
  }

  // 2. 如果目标路由需要认证
  if (to.meta.requireAuth) {

    // 3.检查用户是否已经登录
    if (store.state.accessToken) {
        next();
    }else {
      next({ path: '/login', query: { redirect: to.fullPath } });
    }
  }else {
    next();
  }
});


// 2.axios请求过滤器
axios.interceptors.request.use(
 
  // 1.加入头部信息
  (config) => {

    let token = null;
    
    if (store.state.accessToken !== null) {
      token = store.state.accessToken;
      config.headers.token = token;
    }
    return config;
  }
);


// 1.请求失败的队列
// const failedQueue = []

// 2.刷新状态标志
// let isRefreshing = false;

// 3.刷新完成后的回调队列
// let refreshSubscribers = [];

// // 5.处理队列中的请求
// async function processQueue(accessToken){

//   // 1.先执行所有订阅的回调
//   refreshSubscribers.forEach(cb => cb(accessToken));
//   refreshSubscribers = [];


//   // 处理失败的请求队列
//   while(failedQueue.length > 0){
//     const request = failedQueue.shift();
//     request.config.headers.token = accessToken;
//     try {
//       await axios(request.config)
//     }catch(error) {
//       // 如果再次失败,可以重新加入队列或做其他处理
//       console.log('Retry failed: ', error);
//     }
//   }
// }

// 6.响应拦截器
axios.interceptors.response.use(

  response => {
    if(!response.data){
      response.data = {code: 500, message: '响应数据缺失'};
      return response;
    }

    if(response.config.__isRetryRequest){
      return {
        ...response,
        data: response.data,
        status: response.status,
        headers: response.headers
      }
    }
    return response;
  }, 

  // async error =>{

  //   const { config, response } = error;

  //   // 3.将原始请求配置加入队列
  //   if(response && response.status === 401){
     
  //     // 将原始请求加入失败队列
  //     failedQueue.push({ config });

  //     // 如果不在刷新状态,则开始刷新token
  //     if(!isRefreshing) {
  //       isRefreshing = true;

  //       try {

  //         const newToken =  await refreshTokenInfo();

  //         const accessToken = newToken.data.data.accessToken;

  //         store.commit('updateToken', newToken)

  //         // 处理队列中的请求
  //         await processQueue(accessToken);

  //         store.commit('SET_RETRY_DATA')
  //       }finally {
  //         isRefreshing = false;
  //       }

  //     }

  //     // 返回一个等待token刷新完成的Promise
  //     return  new Promise(resolve =>{
  //       refreshSubscribers.push(token => {
  //         config.headers.token = token

  //         resolve(axios(config).then(res =>({
  //           ...res,
  //           __isRetryRequest: true 
  //         })));
  //       })
  //     })
  //   }
  //   return Promise.reject(error);
  // }
);


// 4.刷新token的函数
// async function refreshTokenInfo(){
//   try {
//     const response = await axios.post('/refreshToken', { refreshToken: store.state.refreshToken });

//     return response;
//   } catch(error) {
//     console.log('刷新token失败: ', error);
//   }
// }

// 菜单初始化方法
let initAdminMenu = (router, store) => {

  // 防止重复触发加载菜单操作
  if (store.state.adminMenus.length > 0) {
    return
  } else {

    // 查询菜单集合方法
    axios.get('/admin/menu').then(resp => {

      // 调用查询菜单的方法之后,进行处理
      if (resp && resp.data.code === 200) {

        var fmtRoutes = formatRoutes(resp.data.data);

        router.addRoutes(fmtRoutes);
        
        store.commit('initAdminMenu', fmtRoutes);

      }
    })
  }
}


// 对后端查询的菜单列表进行转化
let formatRoutes = (routes) => {
  
  // 定义一个数组
  let fmtRoutes = []
  
  // 遍历路由
  routes.forEach(route => {

    // 查看每一个路由当中是否存在子菜单
    if (route.children) {
      route.children = formatRoutes(route.children)
    }
    
    // 封装一个对象,用来存放路由信息
    let fmtRoute = {

      // 菜单路由id,也就是 menuId 
      id: route.menuId,

      // 与 Vue 路由中的 path 对应，即地址路径： /admin
      path: route.menuUrl,

      // 组件名，用于解析路由对应的组件。即路由中的 component： '../components/admin/user/UserManager'
      component: resolve => {
        require(['./components/admin/' + route.component + '.vue'], resolve)
      },

      // 路由名称
      name: route.menuName,

      // 页面中文名,用来渲染导航栏 (菜单栏)页面
      nameZh: route.nameZh,

      // 页面图标
      iconCls: route.menuIcon,

      // 子级菜单
      children: route.children
    }
    // 组装之后的菜单路由
    fmtRoutes.push(fmtRoute);

  })

  return fmtRoutes;
}


// 创建实例对象---vm
new Vue({
  router, 
  store,

  // 完成了这个功能：将App组件放入到容器中
  render: h => h(App)
}).$mount('#app')
